import { focusManager, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';

import { chatKeys } from '../../api/query-keys';
import { type ContextRefreshEffects, createContextRefreshEffects } from './context-refresh-effect';

/** The query cache work the AG-UI conversation does outside a query or mutation. */
export const useChatAgentQueryCache = () => {
    const queryClient = useQueryClient();

    return useMemo(
        () => ({
            createContextRefreshEffects: (): ContextRefreshEffects => createContextRefreshEffects(queryClient),
            invalidateThreadList: (): void => {
                void queryClient.invalidateQueries({ queryKey: chatKeys.threads(), exact: true });
            },
            /** Follows React Query's window focus, so a returning window reads the thread like a refetch on focus. */
            subscribeToWindowFocus: (listener: (isFocused: boolean) => void): (() => void) =>
                focusManager.subscribe(listener),
        }),
        [queryClient],
    );
};
